import HeaderRates from "../modal/computation/rates/header-rates";
import { RateGroup, RatesInfo } from "../../../../features/actuarial/rates-state";

interface Props {
    title: string;
    theadTitles: string[];
    firstTheadTitle: string;
    typeOfRates: boolean;
    rates: RatesInfo[];
    ratesPerAge: RateGroup[];
    isShow: boolean;
}

export default function RatesView({ isShow, title, theadTitles, firstTheadTitle, typeOfRates, rates, ratesPerAge }: Props) {
    if (!isShow) return null;

    const renderRateInput = (amount: string | number | null | undefined) => (
        <input readOnly type="text" value={amount ?? ""} className="w-full min-w-[70px] border-0 bg-transparent px-1 text-center text-[11px] text-gray-700 outline-none" />
    );

    // CHANGED: Fixed width for the first column.
    const firstColumnClass = "sticky left-0 z-10 w-[140px] min-w-[140px] max-w-[140px] whitespace-nowrap";

    return (
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
            <div className="flex min-h-[42px] items-center justify-between border-b border-gray-200 bg-[#186cb2]/10 px-3 py-2">
                <HeaderRates title={title} fontSize="text-xs" fontWeight="font-semibold" />
                <span className="hidden text-[10px] text-gray-400 sm:block">View only</span>
            </div>

            <div className="w-full overflow-x-auto">
                <table className="w-full min-w-max border-collapse">
                    <thead>
                        <tr className="bg-gray-50">
                            {/* CHANGED: Fixed width applied to first header. */}
                            <th className={`${firstColumnClass} border-b border-r border-gray-200 bg-gray-50 px-3 py-2 text-center text-[11px] font-semibold text-gray-600`}>{firstTheadTitle}</th>

                            {theadTitles?.map((item, index, array) => (
                                <th key={index} title={item} className={`whitespace-nowrap border-b border-r border-gray-200 px-3 py-2 text-center text-[11px] font-semibold text-gray-600 ${index === array.length - 1 ? "border-r-0" : ""}`}>{item}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {!typeOfRates ? (
                            rates?.map((termItem, groupIndex) => (
                                <tr key={groupIndex} className={`border-b border-gray-100 last:border-b-0 ${groupIndex % 2 === 0 ? "bg-white" : "bg-gray-50/50"} hover:bg-[#186cb2]/5`}>
                                    {/* CHANGED: Same fixed width applied to first body column. */}
                                    <td className={`${firstColumnClass} ${groupIndex % 2 === 0 ? "bg-white" : "bg-gray-50"} border-r border-gray-200 px-3 py-1.5 text-center text-[11px] font-medium text-gray-700`}>{termItem.name}</td>

                                    {ratesPerAge.map((group, index, array) => {
                                        const cell = group.data.find((d) => termItem.type === "plan" ? d.type === "plan" && d.plan_id === termItem.plan_id : d.type === "rider" && d.rider_id === termItem.rider_id);

                                        return (
                                            <td key={index} className={`px-2 py-1.5 ${index !== array.length - 1 ? "border-r border-gray-100" : ""}`}>
                                                {renderRateInput(cell?.amount)}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        ) : (
                            ratesPerAge.map((dataRateAge, groupIndex) => (
                                <tr key={groupIndex} className={`border-b border-gray-100 last:border-b-0 ${groupIndex % 2 === 0 ? "bg-white" : "bg-gray-50/50"} hover:bg-[#186cb2]/5`}>
                                    {/* CHANGED: Same fixed width applied to first body column. */}
                                    <td className={`${firstColumnClass} ${groupIndex % 2 === 0 ? "bg-white" : "bg-gray-50"} border-r border-gray-200 px-3 py-1.5 text-center text-[11px] font-medium text-gray-700`}>{dataRateAge.title}</td>

                                    {dataRateAge.data.map((termItem, index, array) => (
                                        <td key={index} className={`px-2 py-1.5 ${index !== array.length - 1 ? "border-r border-gray-100" : ""}`}>
                                            {renderRateInput(termItem.amount)}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}